<div class="periodo-container">
  <div class="date-picker-wrapper">
    <button class="date-picker-trigger" [class.active]="dropdownAberto" (click)="toggleDropdown()">
      <i class="fe-calendar trigger-icon"></i>
      <div class="trigger-text">
        <span class="trigger-label">PERÍODO</span>
        <span class="trigger-value">{{obtenhaLabelPeriodo()}}</span>
      </div>
      <i class="trigger-arrow" [ngClass]="dropdownAberto ? 'fe-chevron-up' : 'fe-chevron-down'"></i>
    </button>

    <div class="date-picker-dropdown" *ngIf="dropdownAberto">
    <div class="dropdown-body">
      <div class="date-presets">
        <div class="preset-item" [class.active]="quickDateFilter === 'hoje'" (click)="selecionarPreset('hoje')">Hoje</div>
        <div class="preset-item" [class.active]="quickDateFilter === 'ontem'" (click)="selecionarPreset('ontem')">Ontem</div>
        <div class="preset-item" [class.active]="quickDateFilter === '7dias'" (click)="selecionarPreset('7dias')">Últimos 7 dias</div>
        <div class="preset-item" [class.active]="quickDateFilter === '30dias'" (click)="selecionarPreset('30dias')">Últimos 30 dias</div>
        <div class="preset-item" [class.active]="quickDateFilter === 'mes'" (click)="selecionarPreset('mes')">Este mês</div>
        <div class="preset-item" [class.active]="quickDateFilter === 'mesAnterior'" (click)="selecionarPreset('mesAnterior')">Mês passado</div>
        <div class="preset-item" [class.active]="quickDateFilter === 'personalizado'" (click)="selecionarPreset('personalizado')">Personalizado</div>
      </div>

      <div class="date-month-selector">
        <div class="year-nav">
          <button class="year-nav-btn" (click)="anoAnterior(); $event.stopPropagation()">‹</button>
          <span class="year-label">{{anoSelecionado}}</span>
          <button class="year-nav-btn" (click)="proximoAno(); $event.stopPropagation()">›</button>
        </div>
        <div class="months-grid">
          <div *ngFor="let m of meses; let i = index"
               class="month-cell" [class.active]="mesSelecionadoAtivo(i)"
               (click)="selecionarMes(i); $event.stopPropagation()">
            {{m}}
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-footer">
      <kendo-daterange class="date-inputs">
        <kendo-dateinput kendoDateRangeStartInput [(ngModel)]="filtroInicio" class="date-input-kendo"></kendo-dateinput>
        <span class="date-separator">—</span>
        <kendo-dateinput kendoDateRangeEndInput [(ngModel)]="filtroFim" class="date-input-kendo"></kendo-dateinput>
      </kendo-daterange>
      <button class="btn-aplicar" (click)="aplicarPeriodo(); $event.stopPropagation()">Aplicar</button>
    </div>
  </div>
  </div>
  <span class="periodo-descricao" *ngIf="filtroInicio && filtroFim">
    Exibindo de <b>{{filtroInicio | date:'dd/MM/yyyy'}}</b> até <b>{{filtroFim | date:'dd/MM/yyyy'}}</b>
  </span>
</div>
